var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-menu",style:({
    display: _vm.rightMenuStatus,
    top: _vm.rightMenuTop,
    left: _vm.rightMenuLeft,
  }),attrs:{"id":"rightMenuDom"}},[_c('p',{on:{"click":_vm.handleCopy}},[_c('a-icon',{attrs:{"type":"copy"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('复制')))])],1),_vm._v(" "),(_vm.retractMsgId && _vm.rightMenu.originalInfo.id === _vm.retractMsgId)?_c('p',{on:{"click":_vm.handleWithdraw}},[_c('a-icon',{attrs:{"type":"rollback"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('撤回')))])],1):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }